const breakpoints = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
}

export const mq = Object.fromEntries(
  Object.entries(breakpoints).map(entry => [
    entry[0],
    `@media (min-width: ${entry[1]}px)`,
  ])
)
